import { render } from "./BaseDialog.vue?vue&type=template&id=e08db52a&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=js"
export * from "./BaseDialog.vue?vue&type=script&lang=js"

import "./BaseDialog.vue?vue&type=style&index=0&id=e08db52a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e08db52a"

export default script